import React from "react";

const DateTimePicker = ({ label, value, onChange, min, max, required, error, className = "" }) => {
  const formatDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleChange = (e) => {
    const dateValue = e.target.value ? new Date(e.target.value) : null;
    onChange(dateValue);
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-text dark:text-neutral-light mb-2">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <input
        type="datetime-local"
        value={formatDateTimeLocal(value)}
        onChange={handleChange}
        min={min ? formatDateTimeLocal(min) : undefined}
        max={max ? formatDateTimeLocal(max) : undefined}
        required={required}
        className={`
          w-full px-4 py-2 
          border border-neutral-light dark:border-neutral-dark 
          rounded-lg
          bg-background dark:bg-glass-dark 
          text-text dark:text-neutral-light
          focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary
          transition-colors duration-200
          ${error ? "border-danger" : ""}
        `}
      />
      {error && (
        <p className="mt-1 text-sm text-danger">{error}</p>
      )}
    </div>
  );
};

export default DateTimePicker;
